import DxTable from "features/common/components/DXTable/DXTable";

import { Box, FormControlLabel, Radio } from "@mui/material";
import DXIcon from "features/common/components/DXIcon";
import DXModal from "features/common/components/DXModal/DXModal";
import { Icon } from "features/common/components/Icon";
import QBButton from "features/common/components/QBButton/QBButton";
import QBLogoutButton from "features/common/components/QBButton/QBLogoutButton";
import useConnectQuickbooks from "hooks/useConnectQuickbooks";
import useCurrentUser from "hooks/useCurrentUser";
import { useEffect, useState } from "react";
import { Account } from "redux/types";
import { deleteData, getData, post } from "services/api";
import {
  ComponentTitle,
  Container,
  IconAction,
  Input,
  QBStep,
  Subtitle,
  Title,
  Wrapper,
  WrapperTable,
} from "./TableProfile.styles";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "redux/reducers";
import { setCurrentCompany, setDXUserData } from "redux/actions";
import { getPermissionsByOrgAndCompRole } from "utils/rbac";
import { ModalDeleteCompany } from "../ManageCompanies/ModalDeleteCompany";
import ModalAddExistingQBAccount from "features/common/components/AddExistingQBAccount/ModalAddExistingQBAccount";
import { QBLogoutModal } from "features/common/components/QBLogoutModal/QBLogoutModal";


interface TableProfileProps {
  accounts: Account[];
}

export const TableProfile = ({ accounts }: TableProfileProps) => {
  const [companyId, setCompanyId] = useState("");
  const params = new URLSearchParams(window.location.search);
  const isReconnect = params.get("connected") === "false";
  const companyIdParam = params.get("id");
  const { currentCompany } = useSelector((state: RootState) => state);
  const [orgCompanies, setOrgCompanies] = useState(currentCompany?.account?.companies || []);
  const { userData } = useCurrentUser();
  const dispatch = useDispatch();
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const [companyIdToDelete, setCompanyIdToDelete] = useState(null);
  const [enableDelete, setEnableDelete] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [isExistingQB, setIsExistingQB] = useState(false);
  const [confirmLogoutModal, setConfirmLogoutModal] = useState(false);

  const orgRole = currentCompany?.account?.role;
  const compRole = currentCompany?.company?.role;
  const rbac = currentCompany?.rbac;
  const permissions = getPermissionsByOrgAndCompRole(orgRole, compRole, rbac);

  useEffect(() => {
    setOrgCompanies(currentCompany?.account?.companies || []);
  }, [currentCompany]);

  const handleChange = (event) => {
    if (event === "DELETE ACCOUNT") {
      setEnableDelete(true);
    } else {
      setEnableDelete(false);
    }
  }

  const [tableData, setTableData] = useState(
    orgCompanies.map(company => {
      let role = company.role.toLowerCase();
      role = role.charAt(0).toUpperCase() + role.slice(1);
      return {
        id: company.id,
        userName: company.name,
        numberOfUsers: company?.number_of_users,
        role,
      };
    }) || []
  );



  useEffect(() => {
    if (accounts && accounts[0]?.companies) {
      setTableData(
        orgCompanies.map((company) => {
          let role = company.role.toLowerCase();
          role = role.charAt(0).toUpperCase() + role.slice(1);
          return {
            id: company.id,
            userName: company.name,
            numberOfUsers: company?.number_of_users,
            role,
          };
        })
      );
    }
  }, [orgCompanies, accounts]);
  console.log({companyIdToDelete})

  const handleDelete = async (companyId) => {
    deleteData(`memberships/company/${companyId}`)
      .then(async () => {
        setTableData((prevData) =>
          prevData.filter((row) => row.id !== companyId)
        );
        const resp = await getData(`/memberships/user/profile`);
        const account = resp.accounts.find((acc) => acc?.id === currentCompany?.account?.id);
        let company = account.companies.find((comp) => comp?.id === currentCompany?.company?.id);
        const rbac = resp.rbac;
        if (!company) {
          company = account.companies[0];
        }
        dispatch(setDXUserData(resp));
        dispatch(setCurrentCompany({ account, company, rbac }));
        toast.success("Company deleted successfully!");
        setIsOpenDeleteModal(false);
      })
      .catch((error) => {
        console.error("Error deleting user:", error);
      });
  };

  const handleLogout = async (companyId) => {
    try {
      await post("quickbooks/revoke-credentials", {
        membership_company_id: companyId,
      });
      toast.success("Logged out of QuickBooks successfully");
    } catch (error) {
      console.error("Error logging out of QuickBooks:", error);
      toast.error("Error logging out of QuickBooks");
    }
  };

  const handleCloseDeleteModal = () => {
    setIsOpenDeleteModal(false);
    setCompanyIdToDelete(null);
    setEnableDelete(false);
  };

  const handleQBconnection = async () => {
    setConfirmLogoutModal(false);
    setIsExistingQB(true)
  }
  

  const columns = [
    {
      field: "userName",
      headerName: "Name",
      flex: 2,
      disableColumnMenu: true,
      align: "center",
      type: "number",
    },
    {
      field: "numberOfUsers",
      headerName: "Number of Users",
      flex: 2,
      disableColumnMenu: true,
      sortable: false,
      align: "center",
    },

    {
      field: "role",
      headerName: "Role",
      flex: 2,
      disableColumnMenu: true,
      sortable: false,
      align: "center",
    },
    {
      field: "QuickBooksOnlineStatus",
      headerName: "QuickBooks Online Status",
      flex: 2,
      disableColumnMenu: true,
      sortable: false,
      align: "center",
      renderCell: (params) => {
        const company = orgCompanies.find(company => company.id === params.row.id);
        if (company?.credentials_id && company.credentials_integration) {
          return (
            <QBButton
              children="Log out"
              endIcon={<DXIcon name="LogoutQuickbook" />}
              logout={true}
              onClick={() => handleLogout(company.id)}
            />
          );
        } else {
          return (
            <QBButton
              children={isReconnect && companyIdParam === company.id ? "Reconnect" : "Connect"}
              endIcon={<DXIcon name="ConnectQuickbook" />}
              onClick={() => {
                setConfirmLogoutModal(true);
                setCompanyId(company.id);
              }}
            />
          );
        }
      },
    },

    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      disableColumnMenu: true,
      align: "center",
      sortable: false,
      renderCell: (params) => (
        <IconAction 
        onClick={() => {
          if (permissions.my_profile.my_client_account.manage_users === 'enable') {
            setIsOpenDeleteModal(true);
            setCompanyIdToDelete(params.row.id);
            setCompanyName(params.row.userName)
          } else {
            return null;
          }
        }}
        style={{ 
          cursor: permissions?.my_profile.my_client_account.manage_users === 'enable' ? 'pointer' : 'not-allowed',
          opacity: permissions?.my_profile.my_client_account.manage_users === 'enable' ? 1 : 0.5,
        }}
        >
          <Icon iconName="trash-01"></Icon>
          Delete
        </IconAction>
      ),
    },
  ];

  return (
    <>
    <WrapperTable>
      <ComponentTitle>
        <Wrapper>
          <Container>
            <Title>My Client Companies</Title>
            <Subtitle> {orgCompanies.length} Company(ies)</Subtitle>
          </Container>
        </Wrapper>
      </ComponentTitle>
      <DxTable
        checkboxField={false}
        rows={tableData}
        columns={columns}
        className="profile"
      />
      <QBLogoutModal 
        openModal={confirmLogoutModal}
        onClose={() => setConfirmLogoutModal(false)}
        logoutConfirmed={handleQBconnection}
        className='clientAccount'
      />
      <ModalAddExistingQBAccount 
        openModal={isExistingQB}
        onClose={() => setIsExistingQB(false)}
        companyId={companyId}
        cognitoId={userData?.sub}
        accountId={currentCompany?.account?.id}
      />
    </WrapperTable >
    {isOpenDeleteModal && (
      <ModalDeleteCompany
        isOpenModalDelete={isOpenDeleteModal}
        setIsOpenModalDelete={handleCloseDeleteModal}
        handleDelete={handleDelete}
        id={companyIdToDelete}
        text={`I acknowledge that the files and databases for ${companyName} will be deleted and that all users will be disconnected from the workspace.`}
        complementaryText="When you delete an account you free up a license to use in the next billing cycle."
        confirmLabel="Delete Forever"
        title="Are you sure you sure you want to delete this account?"
        handleChange={handleChange}
        disabled={!enableDelete}
        isDeleteCompany={true}
      />
    )}
    </>
  );
};
